import React, { Fragment } from 'react';
import { Field } from 'formik';
import Bone from '@lightspeed/cirrus-bone';
import Card, { CardSection } from '@lightspeed/cirrus-card';
import { Divider } from '@lightspeed/flame/Divider';
import { Switch } from '@lightspeed/flame/Switch';
import { IconWarning } from '@lightspeed/flame/Icon/Warning';
import Text from '@lightspeed/cirrus-text';

import { LayoutSection } from 'cirrus/Layout';

/* eslint-disable react/no-array-index-key */
const Skeleton = () =>
  Array(3)
    .fill('')
    .map((_, index) => (
      <Fragment key={index}>
        {!!index && <Divider />}
        <CardSection large>
          <div className="cr-text-left cr-flex cr-justify-between cr-items-center">
            <div className="cr-width-9-12">
              <Text
                element="div"
                body
                bold
                className="cr-pb-1"
                data-test="settings-optional-modules-module-title"
              >
                <Bone width="6em" />
              </Text>
              <Text
                element="div"
                bodySmall
                dimmed
                data-test="settings-optional-modules-module-description"
              >
                <Bone width="15em" />
              </Text>
            </div>

            <div
              className="cr-width-3-12 cr-flex cr-justify-end cr-items-center"
              data-test="settings-optional-modules-module-field"
            >
              <Switch disabled />
            </div>
          </div>
        </CardSection>
      </Fragment>
    ));
/* eslint-enable react/no-array-index-key */

const Features = ({ isLoading, modules }) => {
  const hasModules = !!(modules && modules.length);

  return (
    <LayoutSection
      title="Optional Modules"
      description="Enable additional features to meet your business needs."
    >
      <Card>
        <div data-test="settings-optional-modules-modules">
          {(() => {
            if (isLoading) return <Skeleton />;
            if (!hasModules) {
              return (
                <div
                  className="cr-flex cr-items-center cr-justify-center cr-p-10 cr-m-5"
                  data-test="settings-optional-modules-none-found"
                >
                  <div>
                    <div className="cr-flex cr-justify-center cr-pb-2">
                      <IconWarning size="2rem" color="gray-300" />
                    </div>
                    <div>No modules available</div>
                  </div>
                </div>
              );
            }

            return modules.map(({ id, name, description }, index) => (
              <Fragment key={id}>
                {!!index && <Divider />}
                <CardSection large>
                  <div className="cr-text-left cr-flex cr-justify-between cr-items-center">
                    <div className="cr-width-9-12">
                      <Text
                        element="label"
                        body
                        bold
                        htmlFor={id}
                        data-test="settings-optional-modules-module-title"
                      >
                        {name}
                      </Text>
                      <Text
                        element="div"
                        bodySmall
                        dimmed
                        data-test="settings-optional-modules-module-description"
                      >
                        {description}
                      </Text>
                    </div>

                    <div className="cr-width-3-12 cr-flex cr-justify-end cr-items-center">
                      <Field
                        name={`['${id}']`}
                        render={({ field }) => (
                          <div data-test="settings-optional-modules-module-field">
                            <Switch
                              id={field.name}
                              checked={field.value}
                              onChange={field.onChange}
                            />
                          </div>
                        )}
                      />
                    </div>
                  </div>
                </CardSection>
              </Fragment>
            ));
          })()}
        </div>
      </Card>
    </LayoutSection>
  );
};

export default Features;
